var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/ProductionListings/ProductionListingsInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/ProductionListings/ProductionListingsInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"ProductionListingsInner\">\n        ";
frame = frame.push();
var t_8 = runtime.contextOrFrameLookup(context, frame, "data");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("item", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n            <div class=\"ProductionListingsInner-item\">\n                <div class=\"ProductionListingsInner-itemInner\">\n                    <div class=\"ProductionListingsInner-itemBlockInfo\">\n                        <div class=\"ProductionListingsInner-itemBlockInfo-column\">\n                            <span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"status"), env.opts.autoescape);
t_5 += "</span>\n                        </div>\n                        <div class=\"ProductionListingsInner-itemBlockInfo-column\">\n                            <span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"production"), env.opts.autoescape);
t_5 += "</span>\n                        </div>\n                        <div class=\"ProductionListingsInner-itemBlockInfo-column\">\n                            <span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"typ"), env.opts.autoescape);
t_5 += "</span>\n                        </div>\n                        <div class=\"ProductionListingsInner-itemBlockInfo-column\">\n                            <span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"dates"), env.opts.autoescape);
t_5 += "</span>\n                        </div>\n                        <div class=\"ProductionListingsInner-itemBlockInfo-column\">\n                            <span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"studio"), env.opts.autoescape);
t_5 += "</span>\n                        </div>\n                        <div class=\"ProductionListingsInner-itemBlockInfo-column\">\n                            <span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"location"), env.opts.autoescape);
t_5 += "</span>\n                        </div>\n                        <div class=\"ProductionListingsInner-itemBlockInfo-column\">\n                            <span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"state"), env.opts.autoescape);
t_5 += "</span>\n                        </div>\n                        <div class=\"ProductionListingsInner-itemBlockCrossWrapper\">\n                            <div class=\"ProductionListingsInner-itemBlockCrossTable\">\n                                <div class=\"ProductionListingsInner-itemBlockCrossCell\">\n                                    <div class=\"ProductionListingsInner-itemBlockCross\">\n                                        <div class=\"ProductionListingsInner-itemBlockCrossV\"></div>\n                                        <div class=\"ProductionListingsInner-itemBlockCrossH\"></div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"ProductionListingsInner-itemBlockRolled\">\n                        <div class=\"ProductionListingsInner-itemBlockRolled-inner\">\n                            <div class=\"ProductionListingsInner-itemBlockRolled-extraInfo\">\n                            ";
if(runtime.memberLookup((t_9),"studio")) {
t_5 += "<div class=\"ProductionListingsInner-itemBlockRolled-extraInfo-locationMobile\">\n                                    <span>Studio:</span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"studio"), env.opts.autoescape);
t_5 += "\n                                </div>";
;
}
t_5 += "\n                            ";
if(runtime.memberLookup((t_9),"location")) {
t_5 += "<div class=\"ProductionListingsInner-itemBlockRolled-extraInfo-locationMobile\">\n                                    <span>City:</span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"location"), env.opts.autoescape);
t_5 += "\n                                </div>";
;
}
t_5 += "\n                            ";
if(runtime.memberLookup((t_9),"state")) {
t_5 += "<div class=\"ProductionListingsInner-itemBlockRolled-extraInfo-locationMobile\">\n                                    <span>State:</span>";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"state"), env.opts.autoescape);
t_5 += "\n                                </div>";
;
}
t_5 += "\n                                ";
frame = frame.push();
var t_12 = runtime.memberLookup((t_9),"info");
if(t_12) {t_12 = runtime.fromIterator(t_12);
var t_11 = t_12.length;
for(var t_10=0; t_10 < t_12.length; t_10++) {
var t_13 = t_12[t_10];
frame.set("extraItem", t_13);
frame.set("loop.index", t_10 + 1);
frame.set("loop.index0", t_10);
frame.set("loop.revindex", t_11 - t_10);
frame.set("loop.revindex0", t_11 - t_10 - 1);
frame.set("loop.first", t_10 === 0);
frame.set("loop.last", t_10 === t_11 - 1);
frame.set("loop.length", t_11);
t_5 += "\n                                    <div class=\"ProductionListingsInner-itemBlockRolled-extraInfo-item\">\n                                        <div class=\"ProductionListingsInner-itemBlockRolled-extraInfo-itemLeftCol\">\n                                            ";
t_5 += runtime.suppressValue(t_13, env.opts.autoescape);
t_5 += "\n                                        </div>\n                                    </div>\n                                ";
;
}
}
frame = frame.pop();
t_5 += "\n                            </div>\n                            ";
if(env.getFilter("length").call(context, runtime.memberLookup((t_9),"agreement"))) {
t_5 += "\n                                <div class=\"ProductionListingsInner-itemBlockRolled-agreements\">\n                                    <div class=\"ProductionListingsInner-itemBlockRolled-agreements-title\">\n                                        Agreements:\n                                    </div>\n                                    ";
frame = frame.push();
var t_16 = runtime.memberLookup((t_9),"agreement");
if(t_16) {t_16 = runtime.fromIterator(t_16);
var t_15 = t_16.length;
for(var t_14=0; t_14 < t_16.length; t_14++) {
var t_17 = t_16[t_14];
frame.set("agreement", t_17);
frame.set("loop.index", t_14 + 1);
frame.set("loop.index0", t_14);
frame.set("loop.revindex", t_15 - t_14);
frame.set("loop.revindex0", t_15 - t_14 - 1);
frame.set("loop.first", t_14 === 0);
frame.set("loop.last", t_14 === t_15 - 1);
frame.set("loop.length", t_15);
t_5 += "\n                                        <span class=\"ProductionListingsInner-itemBlockRolled-agreements-item\">\n                                            ";
t_5 += runtime.suppressValue(t_17, env.opts.autoescape);
t_5 += "\n                                        </span>\n                                    ";
;
}
}
frame = frame.pop();
t_5 += "\n                                </div>\n                            ";
;
}
t_5 += "\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ";
;
}
}
frame = frame.pop();
t_5 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("ProductionListingsInner");
context.setVariable("ProductionListingsInner", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/ProductionListings/ProductionListingsInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionListings/ProductionListingsInner.jinja
// module id = 60
// module chunks = 0